/* External */
import {
  memo, useEffect, useRef,
} from 'react';
import PropTypes from 'prop-types';

/* Utils */
import { noOp } from '../../utils/functions';

/* Styles */
import './QrCode.scss';

function QrCode({ data, onError = noOp, className = '' }) {
  const canvasEl = useRef();
  const containerEl = useRef();

  /* qrcode@1.4.4 drags node buffer@5 + pngjs into whatever chunk imports it;
     the lib is only needed when a QR actually renders, so load it lazily to
     keep it out of the boot entry. */
  useEffect(() => {
    let cancelled = false;
    const draw = async () => {
      try {
        const { default: QRCode } = await import('qrcode');
        if (cancelled || !canvasEl.current) return;
        const width = containerEl.current?.clientWidth || 0;
        QRCode.toCanvas(
          canvasEl.current,
          data,
          { width },
          (err) => {
            if (err && !cancelled) onError(err);
          },
        );
      } catch (error) {
        if (!cancelled) onError(error);
      }
    };
    draw();
    return () => { cancelled = true; };
  }, [onError, data]);

  return (
    <div
      ref={containerEl}
      className={`dtv-html5-c-qr-code ${className}`}
    >
      <canvas ref={canvasEl} className="dtv-html5-c-qr-code__canvas" />
    </div>
  );
}

QrCode.propTypes = {
  data: PropTypes.string.isRequired,
  onError: PropTypes.func,
  className: PropTypes.string,
};

export default memo(QrCode);
